import { jsx as _jsx } from "react/jsx-runtime";
import classNames from "classnames";
import styles from "./ResponsiveContainer.module.scss";
export const ResponsiveContainer = ({ children, fullWidth = false, size, }) => {
    const currentClassNames = classNames(styles.responsiveContainer, {
        [styles.fullWidth]: fullWidth,
        [styles[size]]: size,
    });
    return (_jsx("div", { "data-testid": "responsiveContainer", className: currentClassNames, children: children }));
};
//# sourceMappingURL=ResponsiveContainer.js.map